<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'headline',
});
</script>

<template>
  <div class="text-xl text-yellow-600 dark:text-yellow-500">
    <slot />
    <span class="text-gray-400 dark:text-gray-600 text-sm">
      <slot name="counter" />
    </span>
  </div>
</template>
